module.exports = __webpack_public_path__ + "img/city_newtaipei3.40cfaa25.png";